import { app } from '../app.module'
app
  /**
   * setNumberFormat 数字フォーマット
   * @param  {number} numberInput 入力値
   * @param  {number} decimals 数値の少数
   * @param  {String} type 種類
   * @param  {boolean} dataPerPost 一投稿あたりの平均フラグ
   * @param  {number} postCount 投稿数
   * @return {String} フォーマットされた結果
   */
  .filter('setNumberFormat', [
    '$filter',
    function ($filter) {
      return function (
        numberInput: number,
        decimals: number,
        type: string,
        dataPerPost: boolean,
        postCount: number
      ) {
        // 結果を初期化('-'と数値が入るためanyを明示している)
        let textOutput = '-'

        // 入力値がある場合
        if (numberInput !== null) {
          // 数率を計算する場合
          if (type === 'number') {
            // 1投稿あたりの平均
            if (dataPerPost === true && postCount !== 0) {
              textOutput = $filter('number')(numberInput / postCount, 1)
            } else {
              textOutput = $filter('number')(numberInput, decimals)
            }
          }
        }
        // フォーマットされた結果
        return textOutput
      }
    },
  ])
  .filter('division', [
    '$filter',
    () => {
      return (value: number, decimal_point = 2) => {
        const scale = 10 ** decimal_point

        return Math.round(value * scale) / scale
      }
    },
  ])
